<ngx-smart-modal
  #codeEditorPopup
  [identifier]="'codeEditorPopup'"
  [style]="{
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100%'
  }"
  [dismissable]="true"
  [closable]="false"
>
  <form [formGroup]="form">
    <ngs-code-editor
      *ngIf="ngxSmartModalService.getModal('codeEditorPopup').isVisible()"
      [theme]="'vs-dark'"
      [codeModel]="codeModel"
      [options]="{
        contextmenu: true,
        minimap: {
          enabled: true
        },
        automaticLayout: true,
        formatOnType: true,
        dimension: {
          height: 700,
          width: 1000
        }
      }"
      (valueChanged)="change($event)"
    ></ngs-code-editor>
  </form>
  <div class="mt-3" style="display: flex; justify-content: space-between">
    <finx-button labeltext="Cancel" (click)="closePopup()"></finx-button>
    <finx-button class="positive" labeltext="Format" (click)="codeEditor?.formatDocument()"></finx-button>
    <finx-button class="positive" labeltext="OK" (click)="saveJson()"></finx-button>
  </div>
</ngx-smart-modal>
